// extracted by mini-css-extract-plugin
module.exports = {"heading1":"styles_heading1__2bJfX"};